import React, { useState, useRef, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Rnd } from 'react-rnd';
import { useEventListener } from 'ahooks';
import { useDebouncedCallback } from '@mantine/hooks';
import { setTempState } from '@starflow/app/store';
import { useGenHistoryVisible } from '@shakkerai/pro-gen-history';
import CloseIcon from '../../../assets/close.svg';
import { setModelsModalState } from '../../../store/state';
import { collectOptions } from '../../../constants';

export const RndWrapper = React.memo((props) => {
  const { genHistoryVisible, hideHistoryModelsBar } = useGenHistoryVisible();
  const { type, rect = {}, offsetX = 0, children, isShowCloseBtn = true } = props;
  const containerRef = useRef(null);
  const [_rect, setRect] = useState();

  const handleCloseWindow = useCallback(() => {
    setTempState({ exclusiveWindow: null });
    setModelsModalState({
      baseTypes: undefined, // 合集不支持
      combinedTagCode: {}, //合集不支持
      keyword: '',
      collectState: {}, // 合集ID，用于记录在123级菜单中是否有点击对应的合集入口
      collectType: collectOptions[0].value,
      collectModels: {}, // 收藏数据 (翻页不生效)
      historyModels: [], // 最近使用数据(翻页不生效)
      hotModels: [], // 热门精选(翻页不生效)
      catesModels: {}, // 具体分类
      isInGlobalSearchState: false, // 全局搜索状态中
      isInGlobalSearching: false, // 全局异步数据搜索中 loading
      globalSearchDataCount: 0, // 全局搜索数据总数
    });
  }, []);

  const handleGlobalClick = useCallback((event) => {
    if (containerRef.current?.contains(event.target)) {
      return;
    }

    if (event.target?.closest(`.images-window`)) {
      return;
    }

    if (event.target?.closest(`.imginfo-window`)) {
      return;
    }

    if (event.target?.closest(`[data-trigger-window="model-${type}"]`)) {
      return;
    }

    if (event.target?.closest('.mantine-Popover-dropdown')) {
      return;
    }

    // setTempState({ exclusiveWindow: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resizeWindow = useDebouncedCallback(() => {
    const res = calcRect();
    setRect(res);
  }, 200);

  const calcRect = useCallback(() => {
    const ww = innerWidth * 0.7;
    let _x = (innerWidth - ww) / 2;
    const hh = innerHeight * 0.8;
    let _y = (innerHeight - hh) / 2;
    return { x: Math.round(_x), y: Math.round(_y), width: Math.round(ww), height: Math.round(hh) };
  }, []);

  // 计算位置
  useEffect(() => {
    // 处理各种各样的弹层关闭
    setTempState({
      tempPickingModel: false,
      tempCheckpoint: null,
      tempCheckpointPickCallback: null,
      tempLoras: null,
      tempLoraPickCallback: null,
      showNormalCkptGide: false,
      showCheckpointAddedTip: false,
      showSuggestionBaseModelTip: false,
      showNewlyFavoritedModelTip: false,
      imagesWindowOpened: null,
      modelImagesWindowOpened: null,
    });
    genHistoryVisible && hideHistoryModelsBar();
    // 计算弹层位置宽高
    if (!rect.x || !rect.y || !rect.width || !rect.height) {
      const res = calcRect();
      setRect(res);
    } else {
      setRect({
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
      });
    }
  }, [rect.x, rect.y, rect.width, rect.height]);

  useEventListener('click', handleGlobalClick);
  useEventListener('resize', resizeWindow);

  if (!_rect) return null;
  return createPortal(
    <Rnd
      position={{ x: _rect.x - offsetX, y: _rect.y }}
      minWidth={400} // 根据业务情况调整，暂定400
      minHeight={300}
      enableResizing={false}
      onDragStop={(_, { x, y }) => setRect({ ..._rect, x: x + offsetX, y })}
      maxHeight={innerHeight * 0.8}
      size={{ width: _rect.width, height: _rect.height }}
      scale={1}
      className="z-[100] overflow-hidden bg-[#F8F9F9] rounded-lg"
      style={{ boxShadow: '0px 2px 24px 0px rgba(0, 0, 0, 0.10)' }}
    >
      <div ref={containerRef} className="flex flex-shrink-0 h-full" data-role="models-window">
        {children}
      </div>
      {isShowCloseBtn && (
        <img
          src={CloseIcon}
          alt="upload"
          className="w-[16px] h-[16px] cursor-pointer absolute right-[22px] top-[22px]"
          onClick={handleCloseWindow}
        />
      )}
    </Rnd>,
    document.body,
  );
});
